export const CLIENT_FIELD_TYPE_ID = "client";
export const DIALOG_FIELD_TYPE_ID = "dialog";